<script setup>
import { computed } from 'vue'

const props = defineProps({
  ignoredReferencePoint: { type: Array, required: false, default: [] },
  importWarning: { type: Boolean, required: false, default: false }
})

const ignoreReferencePointString = computed(() => {
  return props.ignoredReferencePoint.join(', ')
})
</script>

<template>
  <div>
    <v-alert v-if="importWarning" dense type="warning" variant="outlined">
      If you import, the old data will be deleted and the data below will be imported
    </v-alert>
    <v-alert v-if="ignoredReferencePoint.length" dense type="warning" variant="outlined">
      <span v-if="ignoredReferencePoint.length === 1">
        {{ ignoredReferencePoint[0] }} was ignored. Because of not exist Reference Point in database
        or duplicate in import file.
      </span>
      <span v-else>
        These {{ ignoredReferencePoint.length }} Reference Points were ignored:
        {{ ignoreReferencePointString }}. Because it does not contain these reference points in the
        project or they are duplicated in the Excel import file.
      </span>
    </v-alert>
  </div>
</template>
